<template>
    <el-collapse id="ipFilterResult" v-model="activeName" accordion>
        <el-collapse-item name="1">
            <template slot="title">
                <template v-if="!!isI18n">
                    {{$t(title)}}
                </template>
                <template v-else>
                    {{title}}
                </template>
                    <span class="header-icon">
                        <slot name="icon">
                            <i class="iconfont ipiconbars"></i>
                        </slot>
                    </span>
            </template>
            <div v-loading="loading">
                <template v-if="list.length > 0">
                    <ip-filter-item v-for="item in list"
                            :title="item.title"
                            :showImg="item.showImg"
                            :value="item.value"
                            :count="item.count"
                            :checked="item.checked"
                            :isShowCheckbox="isShowCheckbox"
                            @change-filter-item="handleChangeFilterItem(item,$event)"></ip-filter-item>
                </template>    
                <template v-else>
                    <div class="empty-block">
                        <template v-if="!!isI18n">
                            {{$t(noData)}}
                        </template>
                        <template v-else>
                            {{noData}}
                        </template>
                    </div>
                </template>
            </div>
        </el-collapse-item>
    </el-collapse>
</template>

<script>
import ipFilterItem from './IpFilterItem'
export default {
    name:'ipPatentResultFilter',
    components:{
        ipFilterItem
    },
    props:{
        title:{type:String,default:''},
        value:{type:String,default:''},
        type:{type:String,default:''},
        list:{type:Array,default(){return []}},
        active:{type:Boolean,default:false},
        isShowCheckbox:{type:Boolean,default:true},
        loading:{type:Boolean,default:false},
        isI18n:{type:Boolean,default:false},
        noData:{type:String,default:'暂无数据'}
    },
    computed:{
        activeName:{
            get(){ 
                let temp = '-1';
                if(!!this.active){
                    temp = '1';
                }else{
                    temp = '-1'
                }
                return temp
                },
            set(){}
        }
    },
    methods:{
        handleChangeFilterItem(item,checked){
            let temp = [];
            this.$set(item,'checked',checked);
            this.list.forEach(element => {
                if(element.checked){
                    if(this.value === 'checkedCountry'){
                        temp.push(element.value)                    
                    }else{
                        temp.push(element.title)
                    }
                }
            });
            this.$emit('change-filter',this.value,item,temp);
        }
    }
}
</script>

<style lang="scss">
#ipFilterResult .el-collapse-item__header {
    height: 34px;
    line-height: 34px;
    font-size: $sm-font-size;
    background: #f0f3f7;
    padding: 0 15px;
    .el-collapse-item__arrow{
        display: none;
    }
}
</style>
<style lang="scss" scoped>
#ipFilterResult .el-collapse-item__header .header-icon{
    margin: 0 0 0 auto;
    float: right;
}
.empty-block{
    text-align: center;
    color: #999;
    margin-top: 20px;
}
</style>


